import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Store } from '@cartiq/shared';
import { apiGet, apiPut } from './client';
import { queryKeys } from './queryKeys';
import { useAuthStore } from '../stores/authStore';

export function useStore() {
  return useQuery({
    queryKey: queryKeys.store,
    queryFn: () => apiGet<Store>('/stores/me'),
    staleTime: 60 * 1000,
  });
}

export function useUpdateStore() {
  const qc = useQueryClient();
  const setTenant = useAuthStore((s) => s.setTenant);
  return useMutation({
    mutationFn: (patch: Partial<Store>) => apiPut<Store>('/stores/me', patch),
    onSuccess: (store) => {
      qc.setQueryData(queryKeys.store, store);
      // Keep the tenant slug/live-state hint fresh.
      const tenant = useAuthStore.getState().tenant;
      if (tenant) setTenant({ ...tenant, name: store.name, slug: store.slug });
    },
  });
}
